export const redirectMap = new Map([
  ['/', '/home'],
  ['/invoices', '/advances'],
])
